import Backbone from 'backbone';
import ko from 'knockout';
import landingPage from '@bingads-webui-campaign-legacy/crud-adgroup/template/landingPage.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;

    this.viewmodel = {
      url: ko.observable(''),
      isNotReady: ko.observable(false),
    };

    this.viewmodel.url.subscribe(this.urlEntered.bind(this));
    this.viewmodel.isNotReady.subscribe(() => {
      if (this.options.activityLogger) {
        this.options.activityLogger.signal('website not ready clicked');
      }
    });
  }

  get events() {
    return {
      'keyup input.form-control': 'checkForEnter',
    };
  }

  urlEntered() {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal('url change');
    }
    this.trigger('urlEntered', this.viewmodel.url());
  }

  render() {
    this.$el.html(
      landingPage({
        i18n,
        isForVNext: this.options.isForVNext,
      })
    );
    ko.applyBindings(this.viewmodel, this.el);

    return this;
  }

  checkForEnter(e) {
    if (e.keyCode === 13) {
      this.trigger('urlEntered', this.viewmodel.url());
    }
  }
}
